export const CARDS = "CARDS";
export const CARDS_SUCCESS = "CARDS_SUCCESS";
export const CARDS_FAILURE = "CARDS_FAILURE";

export const FETCH_CARDS="FETCH_CARDS";
export const FETCH_CARDS_SUCCESS="FETCH_CARDS_SUCCESS";
export const FETCH_CARDS_FAILURE="FETCH_CARDS_FAILURE";

export const FETCH_USER_CARDS="FETCH_USER_CARDS";
export const FETCH_USER_CARDS_SUCCESS="FETCH_USER_CARDS_SUCCESS";
export const FETCH_USER_CARDS_FAILURE="FETCH_USER_CARDS_FAILURE";

export const FETCH_SINGLE_CARD="FETCH_SINGLE_CARD";
export const FETCH_SINGLE_CARD_SUCCESS="FETCH_SINGLE_CARD_SUCCESS";
export const FETCH_SINGLE_CARD_FAILURE="FETCH_SINGLE_CARD_FAILURE";

export const SEARCH_BY_NAME = "SEARCH_BY_NAME";
export const SEARCH_BY_NAME_SUCCESS = "SEARCH_BY_NAME_SUCCESS";
export const SEARCH_BY_NAME_FAILURE = "SEARCH_BY_NAME_FAILURE";

export const SEARCH_BY_TAG = "SEARCH_BY_TAG";
export const SEARCH_BY_TAG_SUCCESS = "SEARCH_BY_TAG_SUCCESS";
export const SEARCH_BY_TAG_FAILURE = "SEARCH_BY_TAG_FAILURE";

export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const SIGNUP = "SIGNUP";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const VERIFY_ACCOUNT = "VERIFY_ACCOUNT";
export const VERIFY_ACCOUNT_SUCCESS = "VERIFY_ACCOUNT_SUCCESS";
export const VERIFY_ACCOUNT_FAILURE = "VERIFY_ACCOUNT_FAILURE";

export const UPDATE_CARD = "UPDATE_CARD";
export const UPDATE_CARD_SUCCESS = "UPDATE_CARD_SUCCESS";
export const UPDATE_CARD_FAILURE = "UPDATE_CARD_FAILURE";

export const DELETE_CARD = "DELETE_CARD";
export const DELETE_CARD_SUCCESS = "DELETE_CARD_SUCCESS";
export const DELETE_CARD_FAILURE = "DELETE_CARD_FAILURE";


// users
export const FETCH_SINGLE_USER = "FETCH_SINGLE_USER";
export const FETCH_SINGLE_USER_SUCCESS = "FETCH_SINGLE_USER_SUCCESS";
export const FETCH_SINGLE_USER_FAILURE = "FETCH_SINGLE_USER_FAILURE";

export const DEACTIVATE_SINGLE_USER = "DEACTIVATE_SINGLE_USER";
export const DEACTIVATE_SINGLE_USER_SUCCESS = "DEACTIVATE_SINGLE_USER_SUCCESS";
export const DEACTIVATE_SINGLE_USER_FAILURE = "DEACTIVATE_SINGLE_USER_FAILURE";

export const DELETE_SINGLE_USER = "DELETE_SINGLE_USER";
export const DELETE_SINGLE_USER_SUCCESS = "DELETE_SINGLE_USER_SUCCESS";
export const DELETE_SINGLE_USER_FAILURE = "DELETE_SINGLE_USER_FAILURE";
